<template>
  <v-container fluid>
    <v-row>
      <main-header-plat-a />
      <main-header-plat-b :navBItems="navBItems" />
      <v-overlay-loader />
    </v-row>
  </v-container>
</template>

<script>
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';

export default {
  name: 'ProStatisticsCPage',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
    VOverlayLoader,
  },
  data() {
    return {
      navBItems: [
        { name: 'Pacientes Ingresados', to: 'pacientes-ingresados' },
        { name: 'Pruebas Aplicadas', to: 'pruebas-aplicadas' },
        { name: 'Data Ingresada', to: 'data-ingresada' },
      ],
    };
  },
};
</script>
